//countryReducer
export const COUNTRY_CODE_LOADING = 'COUNTRY_CODE_LOADING'
export const COUNTRY_CODE_LOADING_START = 'COUNTRY_CODE_LOADING_START'
export const COUNTRY_CODE_LOADING_ERROR = 'COUNTRY_CODE_LOADING_ERROR'
export const COUNTRY_CODE_LOADING_SUCCESS = 'COUNTRY_CODE_LOADING_SUCCESS'